module.exports = __webpack_public_path__ + "img/Vector_nav_results.4abb9065.svg";